import { supabase } from './supabase';

export const EDUCATIONAL_MEDIA_BUCKET = 'educational-media';

export const getEducationStorageUrl = (bucket, storagePath) => {
  if (!bucket || !storagePath) return null;

  const { data } = supabase.storage.from(bucket).getPublicUrl(storagePath);
  return data?.publicUrl || null;
};

export const resolveEducationMediaUrl = (media) => {
  if (!media) return null;
  if (media.media_url) return media.media_url;
  if (media.source_type !== 'supabase_storage') return null;
  return getEducationStorageUrl(media.storage_bucket || EDUCATIONAL_MEDIA_BUCKET, media.storage_path);
};
